// USER
export const ADD_USER = 'ADD_USER';
export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CANCEL_CREATE_USER = 'CANCEL_CREATE_USER';
export const REFRESH_USER_INFO = 'REFRESH_USER_INFO';
export const USER_EMAIL_CHANGE = 'USER_EMAIL_CHANGE';
export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_LOGS = 'GET_USER_LOGS';
export const GET_USER_LOGS_SUCCESS = 'GET_USER_LOGS_SUCCESS';
export const GET_PAGINATED_USER_LOGS = 'GET_PAGINATED_USER_LOGS';
export const GET_PAGINATED_USER_LOGS_SUCCESS = 'GET_PAGINATED_USER_LOGS_SUCCESS';
export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const SELECT_USER = 'SELECT_USER';
export const EDIT_USER = 'EDIT_USER';
export const CANCEL_EDIT_USER = 'CANCEL_USER_EDIT';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const SET_USER_CLIENT = 'SET_USER_CLIENT';
export const SET_USER_CLIENT_SUCCESS = 'SET_USER_CLIENT_SUCCESS';
export const DELETE_USER_CLIENT = 'DELETE_USER_CLIENT';
export const DELETE_USER_CLIENT_SUCCESS = 'DELETE_USER_CLIENT_SUCCESS';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_ROLE_SUCCESS = 'SET_USER_ROLE_SUCCESS';
export const DELETE_USER_ROLE = 'DELETE_USER_ROLE';
export const DELETE_USER_ROLE_SUCCESS = 'DELETE_USER_ROLE_SUCCESS';
export const USERS_ERROR = 'USERS_ERROR';
export const CHANGE_USER_ROLE = 'CHANGE_USER_ROLE';
export const CHANGE_USER_ROLE_SUCCESS = 'CHANGE_USER_ROLE_SUCCESS';
export const SYNC_INIT_START = 'SYNC_INIT_START';
export const SYNC_INIT_STOP = 'SYNC_INIT_STOP';
export const SYNC_META_START = 'SYNC_META_START';
export const SYNC_META_STOP = 'SYNC_META_STOP';
export const SYNC_INIT = 'SYNC_INIT';
export const SYNC_META = 'SYNC_META';
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
